import React from "react";
import Container from "../components/Container";
import { MarkdownStyle } from "../components/markdown/Markdown";
import Button from "../components/form/button";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import { motion } from "framer-motion";

export default function Portfolio() {
    return (
        <Container className="mt-4 lg:mt-8 xl:mt-16">
            <Helmet>
                <title>ReinVB — Portfolio</title>
                <meta name="description" content="What are the projects Rein worked on!" />
            </Helmet>
            <MarkdownStyle className="max-w-full">
                <h1>Portfolio.</h1>
                <motion.hr animate={{ width: "100%" }} transition={{ duration: 2 }} className={`-mt-6 w-0 max-w-[9rem] rounded border-t-4 border-emerald-400 dark:border-emerald-400`} />
            </MarkdownStyle>
            <div className="mt-8 grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
                <div className="rounded-lg border-2">
                    <img src="./images/hermes.jpg" alt="" className="w-full rounded-t-md object-cover" />
                    <div className="rounded-b-md border-t-4 border-blue-400 p-4">
                        <h2 className="mb-4 text-lg font-bold">Hermesgent</h2>
                        <p className="text-slate-600 dark:text-slate-400">A website made for my student group of Industrial Engineers</p>
                        <Link to="hermes">
                            <Button className="group mt-4 gap-2">
                                Read more
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" className="h-4 w-4 transition-all group-hover:ml-1">
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M4.5 12h15m0 0l-6.75-6.75M19.5 12l-6.75 6.75" />
                                </svg>
                            </Button>
                        </Link>
                    </div>
                </div>
                <div className="rounded-lg border-2">
                    <img src="./images/recruitment.jpg" alt="" className="w-full rounded-t-md object-cover" />
                    <div className="rounded-b-md border-t-4 border-yellow-400 p-4">
                        <h2 className="mb-4 text-lg font-bold">Hermes Recruitment</h2>
                        <p className="text-slate-600 dark:text-slate-400">A website made for the recruimtent section of Hermes</p>
                        <Link to="recruitment">
                            <Button className="group mt-4 gap-2">
                                Read more
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" className="h-4 w-4 transition-all group-hover:ml-1">
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M4.5 12h15m0 0l-6.75-6.75M19.5 12l-6.75 6.75" />
                                </svg>
                            </Button>
                        </Link>
                    </div>
                </div>
            </div>
        </Container>
    );
}
